import getAppProvider from "./appProvider";
import {
  getUserProfile,
  extendUserSession,
  videoStreamHeartBeat,
  getUserProfileList,
  getAvatarList,
  updateProfile,
  createProfile,
  deleteProfile,
  loginProfile,
  logoutProfile,
  doAccessTokenRenewal,
} from "./userProfile";
import getHubs from "./hubs";
import { getChannels, getChannelPrograms, getChannelDetails, getChannelById, getSubscribedChannels } from "./epg";
import { getProgramDetail, getRecordingProgramDetail } from "./program";
import { getUserProfileRecording } from "./recordings";
import { getSeriesDetail } from "./series";
import getCastDetail from "./cast";
import getSvodItems from "./svodItems";
import { getSearchContent } from "./search";
import { getSeasonDetails, getSeasonData, getSeasonEpisodesForGuestUser } from "./seasonDetail";
import { getSimilarItems } from "./similarItems";
import getSubCategoryPageItems from "./subCategory";
import { addToFavourites, removeFromFavourites } from "./favourites";
import { getProgramSchedules } from "./schedules";
import { bookmarkAVSVideo, createBookmark, updateBookmark } from "./bookmark";
import retrieveAvsItems from "./retrieveAvsItems";
import { authenticateUser } from "./login";
import { logout } from "./logout";
import getContentUserData from "./contentUserData";
import { fetchVideoUrl, fetchVideoToken } from "./videoContent";
import {
  setParentalPINAvailability,
  updateParentalPIN,
  validateParentalPIN,
  updateParentalControlRatingLevel,
} from "./parentalControl";
import makePurchase, { setPurchasePINAvailability, updatePurchasePIN, validatePurchasePIN } from "./purchase";
import { getNextProgram } from "./getNextProgram";
import getFavourites from "./fetchFavourites";
import alternateLogin from "./alternateLogin";

const middleware = {
  getAppProvider,
  getUserProfile,
  getUserProfileList,
  getAvatarList,
  updateProfile,
  createProfile,
  deleteProfile,
  loginProfile,
  logoutProfile,
  getHubs,
  getChannels,
  getChannelPrograms,
  getChannelDetails,
  getProgramDetail,
  getRecordingProgramDetail,
  getSeriesDetail,
  getCastDetail,
  getSvodItems,
  getSearchContent,
  getSeasonDetails,
  getSimilarItems,
  getSubCategoryPageItems,
  addToFavourites,
  removeFromFavourites,
  makePurchase,
  getProgramSchedules,
  getChannelById,
  getSubscribedChannels,
  retrieveAvsItems,
  authenticateUser,
  logout,
  getContentUserData,
  fetchVideoUrl,
  fetchVideoToken,
  extendUserSession,
  getSeasonData,
  videoStreamHeartBeat,
  bookmarkAVSVideo,
  createBookmark,
  updateBookmark,
  setParentalPINAvailability,
  updateParentalPIN,
  validateParentalPIN,
  setPurchasePINAvailability,
  updatePurchasePIN,
  validatePurchasePIN,
  updateParentalControlRatingLevel,
  getNextProgram,
  getFavourites,
  getUserProfileRecording,
  alternateLogin,
  getSeasonEpisodesForGuestUser,
  doAccessTokenRenewal,
};

export default middleware;
